const crypto = require("crypto");

const algorithm = "aes-256-cbc";
const password = process.env.TOKEN_SECRET; // Kunci rahasia yang digunakan untuk enkripsi dan dekripsi

export function encrypt(text, pass = password) {
  const iv = crypto.randomBytes(16);
  const key = crypto.pbkdf2Sync(pass, iv, 100000, 32, "sha512");
  // const key = crypto.scryptSync(pass, iv, 32);
  const cipher = crypto.createCipheriv(algorithm, key, iv);
  let encrypted = cipher.update(text, "utf8", "hex");
  encrypted += cipher.final("hex");
  return {
    iv: iv.toString("hex"), // Konversi IV ke string hex untuk penyimpanan
    encryptedText: encrypted,
  };
}

export async function encryptAsync(text, pass = password) {
  return new Promise((resolve, reject) => {
    try {
      const iv = crypto.randomBytes(16);
      const key = crypto.pbkdf2Sync(pass, iv, 100000, 32, "sha512");
      // const key = crypto.scryptSync(pass, iv, 32);
      const cipher = crypto.createCipheriv(algorithm, key, iv);
      let encrypted = cipher.update(text, "utf8", "hex");
      encrypted += cipher.final("hex");

      const token_encrypt = encrypted + "/" + iv.toString("hex");

      resolve({
        encryptedText: token_encrypt,
      });
    } catch (err) {
      reject(err);
    }
  });
}
export async function decryptAsync(encryptedText, pass = password) {
  return new Promise((resolve, reject) => {
    try {
      const value = encryptedText.split("/");
      const iv = Buffer.from(value[1], "hex");
      const key = crypto.pbkdf2Sync(pass, iv, 100000, 32, "sha512");
      const decipher = crypto.createDecipheriv(algorithm, key, iv);
      let decrypted = decipher.update(value[0], "hex", "utf8");
      decrypted += decipher.final("utf8");
      resolve(decrypted);
    } catch (err) {
      reject(err);
    }
  });
}

export function decrypt(encryptedText, pass = password) {
  const value = encryptedText.split("/");
  const iv = Buffer.from(value[1], "hex");
  const key = crypto.pbkdf2Sync(pass, iv, 100000, 32, "sha512");
  const decipher = crypto.createDecipheriv(algorithm, key, iv);
  let decrypted = decipher.update(value[0], "hex", "utf8");
  decrypted += decipher.final("utf8");
  return decrypted;
}

export function decrypter(encryptedText) {
  const value = encryptedText.split("/");
  const iv = Buffer.from(value[1], "hex");
  const key = crypto.pbkdf2Sync("say_lalisa_love_me_lalisa_love_me_hey", iv, 100000, 32, "sha512");
  const decipher = crypto.createDecipheriv(algorithm, key, iv);
  let decrypted = decipher.update(value[0], "hex", "utf8");
  decrypted += decipher.final("utf8");
  console.log(decrypted);
  return decrypted;
}

function _arrMenu(arr, newArray) {
  return new Promise((resolve) => {
    arr.forEach((item) => {
      let newItem = {
        label: item.nama,
        icon: item.icon,
        to: item.to,
      };
      if (item.items) {
        newItem.items = [];
        _arrMenu(item.items, newItem.items);
      }
      newArray.push(newItem);
    });
    resolve(newArray);
  });
}

export async function listingMenu(data) {
  const arr = JSON.parse(data);
  let newArray = [];
  let res = await _arrMenu(arr, newArray);
  return res;
}
